module.exports = __webpack_public_path__ + "assets/img/7c6b62764bb8ea81408e5b6860b87d7a.png";